/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import React, {useContext} from 'react'
import {ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material'
import {AccountBox, ExitToApp} from '@mui/icons-material'
import {setMyProfileOpen} from '../../../store/appsSlice'
import {useDispatch} from 'react-redux'
import {FormattedMessage} from 'react-intl'
import {
  AuthContext,
  detectLocale,
  useError,
  useLocale,
  useThemeName,
  useTimeZone,
  useUserId
} from '@enisco/mcc-react-lib'

export const UserOptions: React.FC<{
  anchorEl: Element | undefined
  setAnchorEl: (el: Element | undefined) => void
}> = ({anchorEl, setAnchorEl}) => {
  const authContext = useContext(AuthContext)
  const closeMenu = () => {
    setAnchorEl(undefined)
  }
  const dispatch = useDispatch()
  const [, setThemeName] = useThemeName()
  const [, setLocale] = useLocale()
  const [, setTimezone] = useTimeZone()
  const error = useError()
  const uid = useUserId()
  const openMyProfile = () => {
    dispatch(setMyProfileOpen(true))
    closeMenu()
  }

  const login = () => {
    sessionStorage.redirect = window.location.toString()
    authContext.login().catch((err) => error(err, 'signIn: '))
  }
  const logout = () => {
    closeMenu()
    authContext
      .logout()
      .then(() => {
        setThemeName('dark')
        setLocale(detectLocale(navigator.language.replace('_', '-')).key)
        setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)
      })
      .catch((err) => error(err, 'signOut: '))
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      keepMounted
      onClose={closeMenu}
    >
      <MenuItem onClick={openMyProfile}>
        <ListItemIcon>
          <AccountBox color={'primary'} />
        </ListItemIcon>
        <ListItemText
          primary={
            <FormattedMessage
              id='UserOptions.ProfileSettings'
              defaultMessage='User settings'
            />
          }
        />
      </MenuItem>
      <MenuItem onClick={uid ? logout : login}>
        <ListItemIcon>
          <ExitToApp color={'primary'} />
        </ListItemIcon>
        <ListItemText
          primary={
            uid ? (
              <FormattedMessage
                id='UserOptions.Logout'
                defaultMessage='Logout'
              />
            ) : (
              <FormattedMessage id='UserOptions.Login' defaultMessage='Login' />
            )
          }
        />
      </MenuItem>
    </Menu>
  )
}
